<template>
<div>
    <div class="bg"></div>
    <v-container fluid>
        <v-row>
            <v-col>
                <center>
                    <v-card color="#fff" max-width="400" class="justify-center mt-15">
                    <v-card-title class="headline justify-center">
                        เชื่อมต่อกับแอพไลน์
                    </v-card-title>

                    
                    <v-card-text class="align-center">
                        <center>
                            <v-img src="@/assets/linelink.png" alt="" width="250"></v-img>

                            <br />
                            <p class="align-center">
                                <b>{{ customer.CUSTOMER_NAME }}</b>
                            </p>
                        </center>
                    </v-card-text>

                    <v-card-actions class="justify-center">
                        <v-btn depressed dark color="green" @click="yes" style="width:150px"><b> ใช่, บันทึก </b></v-btn>
                        <v-btn depressed dark color="red" @click="no" style="width:150px"><b> ไม่ใช่, ปิดหน้าต่าง </b></v-btn>
                    </v-card-actions>
                </v-card>
                </center>
                
            </v-col>
        </v-row>
    </v-container>
</div>
</template>

<script>
import liff from "@line/liff";
export default {
    data() {
        return {
            customer: {
                CUSTOMER_NAME: "",
                customerid: "",
                LINE_USERID: "",
            },
        };
    },
    mounted() {
        // // https://liff.line.me/1654997070-KGRN62zW?customerid=847
        // window.location.href = "line://app/1654997070-KGRN62zW?customerid=847";
        console.log(this.$route.query)
        var customerid = this.$route.query.customerid ?
            this.$route.query.customerid :
            this.$route.query["liff.state"].split("?customerid=")[1];
        this.customerid = customerid;
        
        // console.log(customerid);
        if (customerid) {
            liff
                .init({
                    liffId: "1654997070-KGRN62zW",
                })
                .then((data) => {
                    //         // console.log(liff.isLoggedIn());
                    if (liff.isLoggedIn() == false) {
                        liff.login();
                    }
                    liff.getProfile().then((profile) => {
                        // console.log(profile);
                        this.LINE_USERID = profile.userId;
                        const options = {
                            data: {
                                NEWCUSTOMER_ID: customerid,
                            },
                        };
                        // console.log(options);
                        this.$store.commit("Drawer/SET_LOADER", true);
                        this.$guest_api
                            .post("/getCustomerByID", options.data)
                            .then((response) => {
                                console.log(response.data.data);
                                if (response.data.data.length > 0) {
                                    this.customer = response.data.data[0];
                                    // console.log(this.customer);
                                    this.$store.commit("Drawer/SET_LOADER", false);
                                }
                            });
                    });

                    //         //             });
                    //     }).catch((err) => {
                    //         console.log(err)
                });
        }
    },
    methods: {
        yes() {
            this.$store.commit("Drawer/SET_LOADER", true);
            this.$guest_api
                .post("/updateLineUserid", {
                    LINE_USERID: this.LINE_USERID,
                    NEWCUSTOMER_ID: this.customerid,
                })
                .then((response) => {
                    console.log(response.data.data);
                    this.$store.commit("Drawer/SET_LOADER", false);
                    liff
                        .init({
                            liffId: "1654997070-KGRN62zW",
                        })
                        .then((data) => {
                            liff
                                .sendMessages([{
                                    type: "text",
                                    text: "เชื่อมต่อข้อมูลบัญชีท่านกับ" +
                                        this.customer.CUSTOMER_NAME +
                                        " เรียบร้อยแล้ว",
                                }, ])
                                .then(function () {
                                    liff.closeWindow();
                                })
                                .catch(function (error) {
                                    liff.closeWindow();
                                });
                        });
                });
        },
        no() {
            liff.closeWindow();
        }
    },
};
</script>

<style>
.v-card>*:first-child:not(.v-btn):not(.v-chip) {
    font-family: "Prompt", sans-serif !important;
}

.bg {
    background-color: rgb(172, 172, 172) !important;
    width: 100%;
    height: 100%;
    position: fixed;
}
</style>
